import { ScriptModel } from "./ScriptModel";
import { Property } from "./Property";
import { modelPool } from "@modules/model";
export function resolveUid(uid) {
    if (typeof uid !== "number") {
        if (uid instanceof ScriptModel && uid.modelUID !== undefined) {
            uid = uid.modelUID;
        }
        else if (uid.uid !== undefined) {
            uid = uid.uid;
            console.warn("resolveUid received a Model ID", uid);
        }
        else if (uid instanceof Property && uid.getCurrentType() === "UID") {
            uid = uid.getValue();
        }
        else {
            throw new Error(`uid type of ${typeof uid} is not allowed`);
        }
    }
    return uid;
}
export function createModelInstance(modelUID) {
    const model = Object.create(ScriptModel.prototype);
    model.modelUID = modelUID;
    modelPool.getModelOrThrow(modelUID);
    return model;
}
